<template>
  <div class="flex flex-col gap-4">
    <el-form
      :model="params"
      ref="paramForm"
      label-width="0"
      class="flex flex-col gap-4"
      :disabled="disabled"
    >
      <el-form-item
        v-for="(param, idx) in params"
        :key="idx"
        label=""
        :rules="getRules(param)"
        class="border rounded p-4"
      >
        <div class="flex flex-row gap-4 items-center">
          <div class="flex" style="min-width: 80px">
            {{ param.name.capitalize() || "Parameter " + idx }}&colon;
          </div>
          <div class="flex flex-col">
            <!-- Boolean: Switch -->
            <el-switch v-if="param.type === 'Boolean'" v-model="param.value" />
            <!-- Number: Input (number only) -->
            <el-input
              v-else-if="param.type === 'Number'"
              v-model.number="param.value"
              type="number"
              :step="0.01"
              placeholder="Enter number"
              style="width: 180px"
            />
            <!-- String: Default Input -->
            <el-input
              v-else-if="param.type === 'String'"
              v-model="param.value"
              placeholder="Enter text"
              style="width: 180px"
            />
            <!-- Object: Render key-value pairs -->
            <div v-else-if="param.type === 'Object'" class="object-param">
              <object-param-editor :disabled="disabled" v-model="param.value" />
            </div>
            <!-- Fallback: Default Input -->
            <el-input
              v-else
              v-model="param.value"
              placeholder="Enter value"
              style="width: 180px"
            />
          </div>
          <div>({{ param.type }})</div>
          <div class="flex-1 break-all" style="line-height: 1.2em">
            <el-input
              v-model="param.desc"
              placeholder="Description"
              style="width: 100%"
            />
          </div>
          <div v-if="!disabled" class="flex items-center justify-center">
            <el-button
              icon="el-icon-delete"
              @click="handleDeleteItem(idx)"
            ></el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="mt-4" v-if="!disabled">
        <div class="flex flex-row justify-start items-center gap-4">
          <el-input
            type="text"
            v-model="parameterName"
            placeholder="Parameter Name"
            style="width: 180px"
          />
          <SmartSelect v-model="selectedType" :options="typeOptions" />
          <el-button type="primary" @click="handleAddParameter">
            Add Parameter
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import SmartSelect from "@/components/SmartControls/SmartSelect.vue";
import ObjectParamEditor from "@/components/ObjectParamEditor.vue";
export default {
  name: "ModelParamList",
  components: {
    SmartSelect,
    ObjectParamEditor,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    typeOptions: () => [
      { id: "String", name: "String" },
      { id: "Number", name: "Number" },
      { id: "Boolean", name: "Boolean" },
      { id: "Object", name: "Object" },
    ],
    params: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      parameterName: "",
      selectedType: "String",
    };
  },
  methods: {
    getRules() {
      // 可扩展参数校验规则
      return [{ required: true, message: "Value required", trigger: "blur" }];
    },
    getDefaultValue(type) {
      switch (type) {
        case "String":
          return "";
        case "Number":
          return 0;
        case "Boolean":
          return false;
        case "Object":
          return {};
        default:
          return null;
      }
    },
    handleAddParameter() {
      this.params.push({
        name: this.parameterName || "param" + (this.params.length + 1),
        type: this.selectedType,
        value: this.getDefaultValue(this.selectedType),
        desc: "",
      });
      this.$emit("input", this.params);
    },
    handleDeleteItem(idx) {
      this.params.splice(idx, 1);
      this.$emit("input", this.params);
    },
  },
};
</script>
